import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  Button,
  TextField,
  FormControl,
  MenuItem,
  Checkbox,
  InputAdornment,
  IconButton,
  CircularProgress,
  FormControlLabel,
  Link,

  Select,
} from "@mui/material";

import { Link as RouterLink } from "react-router-dom";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import api from "../../api/api";
import { ENDPOINTS } from "../../api/endpoints";
import { InputMask } from "@react-input/mask";

export default function SignupForm({ defaultAccountType = "talent" }) {
  const [formData, setFormData] = useState({
    accountType: defaultAccountType,
    fullName: "",
    unionsSelected: [],
    companyName: "",
    phone: "",
    email: "",
    username: "",
    password: "",
    confirmPassword: "",
    termsAgree: false,
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const [unions, setUnions] = useState([]);


useEffect(() => {
  const fetchUnions = async () => {
    try {
      const res = await api.get(
        ENDPOINTS.getUnions()
      );

      if (Array.isArray(res.data)) {
        setUnions(res.data);
      } else {
        setUnions(res.data?.data || []);
      }
    } catch (err) {
      console.error("UNION API ERROR:", err);
    }
  };

  fetchUnions();
}, []);
useEffect(() => {
  setFormData((prev) => ({
    ...prev,
    accountType: defaultAccountType,
  }));
}, [defaultAccountType]);
  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const getPasswordValidation = (password) => {
  return {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[!@#$%^&*(),.?\":{}|<>]/.test(password),
  };
};

const passwordValidation = getPasswordValidation(formData.password);

const validateEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    ? ""
    : "Invalid email format.";

    const handleAccountTypeChange = (type) => {
  setFormData((prev) => {
    const updated = {
      ...prev,
      accountType: type,
    };

    if (type === "talent") {
      updated.companyName = "";
      updated.phone = "";
    }

    if (type === "creator") {
      updated.unionsSelected = [];
    }

    return updated;
  });

  setErrors((prev) => {
    const newErr = { ...prev };

    delete newErr.companyName;
    delete newErr.phone;
    delete newErr.unionsSelected;

    return newErr;
  });
};


 const handleSubmit = async (e) => {
  e.preventDefault();

  const newErrors = {};

  if (!formData.accountType)
    newErrors.accountType = "Required";

  if (!formData.fullName.trim())
    newErrors.fullName = "Required";

  if (formData.accountType === "talent") {
    if (formData.unionsSelected.length === 0) {
      newErrors.unionsSelected = "Select at least one";
    }
  }

  if (
    formData.accountType === "creator" &&
    !formData.companyName
  ) {
    newErrors.companyName = "Required";
  }

  if (formData.accountType === "creator") {
    if (
      !formData.phone ||
      formData.phone.replace(/\D/g, "").length !== 10
    ) {
      newErrors.phone = "Enter valid 10-digit number";
    }
  }

  if (!formData.email)
    newErrors.email = "Required";

  const emailError = validateEmail(formData.email);

  if (emailError)
    newErrors.email = emailError;

  if (!formData.username.trim())
    newErrors.username = "Required";

  const passValidation = getPasswordValidation(
    formData.password
  );

  if (
    formData.confirmPassword &&
    formData.password !== formData.confirmPassword
  ) {
    newErrors.confirmPassword =
      "Passwords do not match";
  }

  const isPasswordValid =
    Object.values(passValidation).every(Boolean);

  if (!isPasswordValid) {
    newErrors.password = "Invalid password";
  }

  if (!formData.termsAgree) {
    newErrors.termsAgree =
      "Please accept terms and conditions";
  }

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  // SPLIT NAME
  const cleanName = formData.fullName
    .trim()
    .replace(/\s+/g, " ");

  const parts = cleanName.split(" ");

  const firstName = parts[0];

  const lastName = parts.slice(1).join(" ");

  // FINAL PAYLOAD
  const payload = {
    firstName,
    lastName,
    email: formData.email,
    userName: formData.username,
    password: formData.password,

    accountType:
      formData.accountType === "creator"
        ? 9
        : 2,

    affiliationName: formData.unionsSelected,

    companyName: formData.companyName || "",

    phone: formData.phone
      ? formData.phone.replace(/\D/g, "")
      : "",
  };

  try {
    setIsLoading(true);

    const res = await api.post(
      ENDPOINTS.addNewUserDetails(),
      payload
    );

    const success =
      res.data?.status?.toLowerCase() === "ok" ||
      res.data?.httpStatusCode === 200;

    if (success) {
      alert("Account created successfully!");

      localStorage.setItem(
        "rememberedUsername",
        formData.username
      );

      window.location.href = "/login";

      return;
    }

    setErrors({
      form:
        res.data?.message ||
        "Unable to create account.",
    });
  } catch (err) {
    const msg =
      err.response?.data?.message ||
      err.response?.data?.error ||
      err.message ||
      "Something went wrong";

    if (msg.toLowerCase().includes("email")) {
      setErrors((p) => ({
        ...p,
        email: "Email already exists.",
      }));

      return;
    }

    if (msg.toLowerCase().includes("user")) {
      setErrors((p) => ({
        ...p,
        username: "Username already exists.",
      }));

      return;
    }

    setErrors({
      form: msg,
    });
  } finally {
    setIsLoading(false);
  }
};
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "650px",
        margin: "0 auto",
      }}
    >
      <form onSubmit={handleSubmit}>
        {/* ACCOUNT TYPE */}
        <Box sx={{ mt: 2 }}>
          {/* <Typography variant="h6">
            Choose the type of account to create
          </Typography>

          <Typography sx={{ pb: 1 }}>
            If you already have an account,
            <Link
              component={RouterLink}
              to="/login"
              sx={{
                color: "#90b5fe",
                ml: 1,
                cursor: "pointer",
              }}
            >
              login here
            </Link>
          </Typography> */}

          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              variant={
                formData.accountType === "talent"
                  ? "contained"
                  : "outlined"
              }
              sx={{
                flex: 1,
                backgroundColor:
                  formData.accountType === "talent"
                    ? "#fff"
                    : "transparent",
                color:
                  formData.accountType === "talent"
                    ? "#000"
                    : "#fff",
                borderColor: "#fff",
              }}
              onClick={() => handleAccountTypeChange("talent")}
            >
              Talent
            </Button>

            <Button
              variant={
                formData.accountType === "creator"
                  ? "contained"
                  : "outlined"
              }
              sx={{
                flex: 1,
                backgroundColor:
                  formData.accountType === "creator"
                    ? "#fff"
                    : "transparent",
                color:
                  formData.accountType === "creator"
                    ? "#000"
                    : "#fff",
                borderColor: "#fff",
              }}
              onClick={() => handleAccountTypeChange("creator")}
            >
              Casting Director / Creator
            </Button>
          </Box>

          {errors.accountType && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {errors.accountType}
            </Typography>
          )}
        </Box>

        {/* FULL NAME */}
        <TextField
          label="Full Name *"
          name="fullName"
          fullWidth
          margin="normal"
          value={formData.fullName}
          onChange={handleChange}
          error={!!errors.fullName}
          helperText={errors.fullName}
        />

        {/* UNION SELECT */}
        {formData.accountType === "talent" && (
     <Box sx={{ position: "relative", width: "100%" }}>
  <FormControl
    fullWidth
    margin="normal"
    sx={{ textAlign: "left" }}
  >
    <Typography sx={{ mb: 0.6, fontWeight: 500, color: "#fff" }}>
      Union Affiliation *
    </Typography>

    <Select
      multiple
      value={formData.unionsSelected}
      onChange={(e) =>
        setFormData((prev) => ({
          ...prev,
          unionsSelected: e.target.value,
        }))
      }
      displayEmpty
      fullWidth
  MenuProps={{
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  PaperProps: {
    sx: {
      maxHeight: 260,
      mt: 1,
    },
  },
}}
      renderValue={(selected) => {
        if (selected.length === 0) {
          return <span style={{ color: "#888" }}>Select Union(s)</span>;
        }
        return selected
          .map(
            (id) =>
              unions.find((x) => x.affiliationId === id)?.affiliationName
          )
          .join(", ");
      }}
      sx={{
        background: "#fff",
        width: "100%",
        "& .MuiSelect-select": {
          display: "flex",
          alignItems: "center",
        },
        "& .MuiSelect-icon": {
          color: "#777",
        },
      }}
    >
      {unions.map((u) => (
        <MenuItem key={u.affiliationId} value={u.affiliationId}>
          <Checkbox
            checked={formData.unionsSelected.includes(u.affiliationId)}
          />
          {u.affiliationName}
        </MenuItem>
      ))}
    </Select>

    {errors.unionsSelected && (
      <Typography color="error" variant="caption">
        {errors.unionsSelected}
      </Typography>
    )}
  </FormControl>
</Box>
        )}

        {/* CREATOR FIELDS */}
        {formData.accountType === "creator" && (
          <>
            <TextField
              label="Company Name *"
              name="companyName"
              fullWidth
              margin="normal"
              value={formData.companyName}
              onChange={handleChange}
              error={!!errors.companyName}
              helperText={errors.companyName}
            />

    <InputMask
  mask="(___) ___-____"
  replacement={{ _: /\d/ }}
  value={formData.phone}
  onChange={(e) =>
    setFormData((prev) => ({
      ...prev,
      phone: e.target.value,
    }))
  }
  component={TextField}
  label="Phone *"
  fullWidth
  margin="normal"
  error={!!errors.phone}
  helperText={errors.phone}
/>
          </>
        )}

        {/* EMAIL */}
        <TextField
          label="Email *"
          name="email"
          fullWidth
          margin="normal"
          value={formData.email}
          onChange={handleChange}
          error={!!errors.email}
          helperText={errors.email}
        />

        {/* USERNAME */}
        <TextField
          label="Username *"
          name="username"
          fullWidth
          margin="normal"
          value={formData.username}
          onChange={handleChange}
          error={!!errors.username}
          helperText={errors.username}
        />

        {/* PASSWORD */}
        <TextField
          label="Password *"
          name="password"
          type={showPass ? "text" : "password"}
          fullWidth
          margin="normal"
          value={formData.password}
          onChange={handleChange}
          error={!!errors.password}
          helperText={errors.password}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPass(!showPass)}
                >
                  {showPass ? (
                    <VisibilityOff />
                  ) : (
                    <Visibility />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {/* PASSWORD CHECKLIST */}
{formData.password.length > 0 && (
          <Box sx={{ mt: 1, ml: 1 }}>
            {[
              {
                label: "At least 8 characters",
                valid: passwordValidation.length,
              },
              {
                label: "One uppercase letter",
                valid: passwordValidation.uppercase,
              },
              {
                label: "One lowercase letter",
                valid: passwordValidation.lowercase,
              },
              {
                label: "One number",
                valid: passwordValidation.number,
              },
              {
                label: "One special character",
                valid: passwordValidation.special,
              },
            ].map((item, index) => (
              <Typography
                key={index}
                sx={{
                  fontSize: "0.85rem",
                  color: item.valid ? "green" : "#999",
                }}
              >
                {item.valid ? "✔" : "○"} {item.label}
              </Typography>
            ))}
          </Box>
        )}

        {/* CONFIRM PASSWORD */}
        <TextField
          label="Confirm Password *"
          name="confirmPassword"
          type={showConfirmPass ? "text" : "password"}
          fullWidth
          margin="normal"
          value={formData.confirmPassword}
          onChange={handleChange}
          error={!!errors.confirmPassword}
          helperText={errors.confirmPassword}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() =>
                    setShowConfirmPass(!showConfirmPass)
                  }
                >
                  {showConfirmPass ? (
                    <VisibilityOff />
                  ) : (
                    <Visibility />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {/* TERMS */}
        <FormControlLabel
          control={
            <Checkbox
  checked={formData.termsAgree}
  onChange={handleChange}
  name="termsAgree"
  sx={{
    color: "#fff",
    "&.Mui-checked": {
      color: "#fff",
    },
  }}
/>
          }
          sx={{color:"#fff"}}
          label={
            <Typography>
              I agree to the{" "}
              <Link
                component={RouterLink}
                to="/terms-and-condition"
                sx={{ color: "#90b5fe" }}
              >
                Terms and Conditions
              </Link>{" "}
              and{" "}
              <Link
                component={RouterLink}
                to="/privacy-policy"
                sx={{ color: "#90b5fe" }}
              >
                Privacy Policy
              </Link>
            </Typography>
          }
        />

        {errors.termsAgree && (
          <Typography color="error" variant="body2">
            {errors.termsAgree}
          </Typography>
        )}

        {/* FORM ERROR */}
        {errors.form && (
          <Typography color="error" textAlign="center">
            {errors.form}
          </Typography>
        )}

        {/* SUBMIT */}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{
            mt: 2,
            backgroundColor: "#90b5fe",
            height: "50px",
          }}
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size={24} />
          ) : (
            "Sign Up"
          )}
        </Button>
      </form>
    </Box>
  );
}